import { render, staticRenderFns } from "./Liberdade.vue?vue&type=template&id=7153b85f&scoped=true"
import script from "./Liberdade.vue?vue&type=script&lang=js"
export * from "./Liberdade.vue?vue&type=script&lang=js"
import style0 from "./Liberdade.vue?vue&type=style&index=0&id=7153b85f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7153b85f",
  null
  
)

export default component.exports